/* RESPONSIBLE TEAM: team-data-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-controllers */
/* eslint-disable ember/no-classic-classes */
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
export default Controller.extend({
  currentStep: 1,
  intl: service(),

  get steps() {
    return [
      { number: 1, name: this.intl.t('apps.app.import.mixpanel.connect') },
      { number: 2, name: this.intl.t('apps.app.import.mixpanel.instructions') },
      { number: 3, name: this.intl.t('apps.app.import.mixpanel.tag') },
      { number: 4, name: this.intl.t('apps.app.import.mixpanel.import') },
    ];
  },
});
